export const accounts = [
	{ account: "NL: Chase - Sapphire Preferred", name: "Sapphire Preferred", group: "NL Credit" },
	{ account: "NL: Chase - United Explorer", name: "United Explorer", group: "NL Credit" },
	{ account: "NL: Chase - Freedom", name: "Freedom", group: "NL Credit" },
	{ account: "NL: Home - CL", name: "CL", group: "NL Credit" },

	{ account: "NL: Checking - D100", name: "Checking", group: "NL Accounts" },
	{ account: "NL: Cash", name: "Cash", group: "NL Accounts" },
	{ account: "NL: Home Saving - S000", name: "Savings", group: "NL Accounts" },

	{ account: "Erin: Chase - Sapphire Preferred", name: "Sapphire Preferred", group: "Erin Accounts" },
	{ account: "Erin: PNC - Points Credit Card", name: "Points CC", group: "Erin Accounts" },
	{ account: "Erin: PNC - CashBack Credit Card", name: "CashBack CC", group: "Erin Accounts" },
	{ account: "Erin: PNC - Checking", name: "Checking", group: "Erin Accounts" },
	{ account: "Erin: PNC - Savings", name: "Savings", group: "Erin Accounts" },

	{ account: "NL: Immerge Checking", name: "Checking", group: "Immerge" },
	{ account: "NL: Immerge Saving", name: "Savings", group: "Immerge" },
	{ account: "NL: Chase - Ink Bold Preferred", name: "Ink Bold Preferred", group: "Immerge" },
	{ account: "NL: Chase - United Business", name: "United Business", group: "Immerge" },

	{ account: "NL: Tax Estimate", name: "Tax Estimate", group: "Tax" },

	{ account: "NL: COIN", name: "Crypto", group: "Investments" },
	{ account: "NL: VAN", name: "Stocks", group: "Investments" },

	{ account: "Erin: 401k", name: "Erin 401k", group: "Retirement" },
	{ account: "NL: IRA", name: "NL IRA", group: "Retirement" },

	{ account: "NL: Capital One - Money Market", name: "Capital One", group: "Inactive" },
	{ account: "NL: Capital One - 3M", name: "Capital One", group: "Inactive" },
	{ account: "NL: Capital One - Tax Savings", name: "Capital One", group: "Inactive" },
	{ account: "NL: Checking - D101", name: "D101", group: "Inactive" },
	{ account: "NL: Home Saving - S007", name: "S007", group: "Inactive" },
];
